import { useState } from 'react';
import { FaCheck, FaEye, FaEyeSlash, FaTimes } from 'react-icons/fa';
import { FieldShell } from './FieldShell';
import { useFieldName, useDomFieldId } from './_useFieldName';
import { onCheckPassword } from './_passwordStrength';
import { FIELD_AUTOCOMPLETE_PASSWORD, FIELD_NO_AUTOFILL } from './_fieldDefaults';

const BLOCK = 'LStudio__app_field';

/*
    🔥 CONTRASEÑA CON MEDIDOR

    Distinto de FieldInput type="password": muestra la fuerza y la
    lista de requisitos, tachando los que se van cumpliendo.

    Los requisitos aparecen recién al escribir: mostrarlos vacíos
    de entrada intimida sin aportar.
*/

export const FieldPasswordStrength = ({
    id, name, label = 'Contraseña', hint, error,
    value = '', onChange, onBlur = null, placeholder = 'Mínimo 8 caracteres',
    showRules = true,
    isRequired = false, isDisabled = false,
    span = 1, ...rest
}) => {

    const [useIsVisible, setIsVisible] = useState(false);

    const CHECK = onCheckPassword(value);

    const PERCENT = (CHECK.score * 100) / CHECK.total;

    const { domName, onChangeField, onBlurField } = useFieldName({ id, name, onChange, onBlur });

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} hint={hint} error={error}
            isRequired={isRequired} isDisabled={isDisabled} span={span} >

            <div className={`${BLOCK}__wrap`}>

                <input id={DOM_ID} data-field={name ?? id} name={domName} type={useIsVisible ? 'text' : 'password'}
                    className={`${BLOCK}__input`}
                    value={value} onChange={onChangeField} onBlur={onBlurField} placeholder={placeholder}
                    required={isRequired} disabled={isDisabled}
                    autoComplete={FIELD_AUTOCOMPLETE_PASSWORD}
                    aria-invalid={!!error} data-has-end={true}
                    {...FIELD_NO_AUTOFILL}
                    {...rest} />

                <button type="button" className={`${BLOCK}__icon ${BLOCK}__icon--end ${BLOCK}__icon--button`}
                    aria-label={useIsVisible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                    onClick={() => setIsVisible(!useIsVisible)} >
                    {useIsVisible ? <FaEyeSlash /> : <FaEye />}
                </button>

            </div>

            {
                value && (
                    <div className={`${BLOCK}__strength`} data-tone={CHECK.level.tone}>

                        <div className={`${BLOCK}__strength_bar`}>
                            <span className={`${BLOCK}__strength_fill`} style={{ width: `${PERCENT}%` }} />
                        </div>

                        <span className={`${BLOCK}__strength_label`}>{CHECK.level.label}</span>

                    </div>
                )
            }

            {
                showRules && value && (
                    <ul className={`${BLOCK}__rules`}>
                        {
                            CHECK.rules.map((rule) => (
                                <li key={rule.id} className={`${BLOCK}__rule`} data-ok={rule.isOk}>
                                    {rule.isOk ? <FaCheck /> : <FaTimes />}
                                    {rule.label}
                                </li>
                            ))
                        }
                    </ul>
                )
            }

        </FieldShell>
    );
};
